<template>
    <ClientOnly>
        <v-form ref="form" v-model="valid" validate-on="lazy blur">
            <v-card>
                <v-card-text>

                    <v-col>
                        <v-row cols="12">
                            <v-radio-group v-model="donateForm.payType" inline label="支付方式" density="compact">
                                <v-radio label="信用卡" value="信用卡"></v-radio>
                                <v-radio v-if="supportApplePay" label="Apple Pay" value="ApplePay"></v-radio>
                                <v-radio label="LINE Pay" value="LINE Pay"></v-radio>
                                <v-radio label="iPASS MONEY" value="iPASS MONEY"></v-radio>
                            </v-radio-group>
                            <v-divider></v-divider>
                        </v-row>
                    </v-col>

                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-select label="捐款用途" hint="*必填" persistent-hint prepend-inner-icon="mdi-bank-outline"
                                v-model="donateForm.purposeId" :items="purpose" item-title="purpose" item-value="id"
                                variant="outlined" density="compact" :rules="[required]"></v-select>
                        </v-row>
                    </v-col>

                    <!-- <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field label="其它用途說明" prepend-inner-icon="mdi-book-heart-outline"
                                v-model="donateForm.purposeMemo" hint="捐款用途若選其它者,請說明用途" persistent-hint density="compact"
                                :rules="[v => !(donateForm.purposeId == 9999 && !!v == false) || '請輸入']" variant="outlined"
                                :readonly="disableMemo"></v-text-field>
                        </v-row>
                    </v-col> -->

                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field label="捐款金額(新台幣)" prepend-inner-icon="mdi-currency-usd"
                                v-model="donateForm.amount" type="number" density="compact"
                                :rules="[required, v => numberRangeRules(v, 100, 500000)]" hint="*必填,捐款金額需大於100元以上"
                                persistent-hint variant="outlined">
                                <template #append-inner>
                                    <v-btn class="mr-1" @click="addAmount(500)" size="small">+500</v-btn>
                                    <v-btn class="mr-1" @click="addAmount(1000)" size="small">+1000</v-btn>
                                </template>

                            </v-text-field>
                        </v-row>
                    </v-col>

                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field label="捐款人姓名" hint="*必填" persistent-hint prepend-inner-icon="mdi-account-circle"
                                v-model="donateForm.name" density="compact" variant="outlined"
                                :rules="[required, v => maxLength(v, 50)]"></v-text-field>
                        </v-row>
                    </v-col>
                    <!-- <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field :rules="[required, IdRules]" label="捐款人身分證字號" prepend-inner-icon="mdi-id-card"
                                v-model="donateForm.id" density="compact" variant="outlined" hint="*必填,供列舉扣除額使用"
                                persistent-hint></v-text-field>
                        </v-row>
                    </v-col> -->

                    <v-divider></v-divider>
                    <v-col class="mt-2">
                        <!-- 若您希望以他人或公司名義開立捐款收據，請務必填寫以下收據人/收據公司資料，如無填寫則依捐款人資料為主 。如未能提供完整的收據資料，可能導致您的捐款無法開立正確的收據，因此請務必確認相關信息無誤。 -->
                         如未能提供完整的收據資料，可能導致您的捐款無法開立正確的收據，因此請務必確認資料正確無誤。
                    </v-col>
                    <v-col class="mt-2">                        
                        <v-row cols="12">                            
                            <v-text-field label="收據人姓名/收據公司抬頭" hint="*必填" persistent-hint prepend-inner-icon="mdi-account-circle"
                                v-model="donateForm.receiptName" density="compact" variant="outlined"
                                :rules="[required,v => maxLength(v, 50)]"></v-text-field>
                        </v-row>
                    </v-col>
                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field label="收據人身分證號碼/收據公司統一編號 " prepend-inner-icon="mdi-id-card"
                                v-model="donateForm.receiptNo" density="compact" variant="outlined" hint="*必填,供列舉扣除額使用"
                                :rules="[required,v => maxLength(v, 20)]"
                                persistent-hint></v-text-field>
                        </v-row>
                    </v-col>

                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-divider></v-divider>
                            <v-checkbox v-model="needPaperReceipt" label="索取紙本收據" dense></v-checkbox>
                        </v-row>
                    </v-col>
                    <v-col class="mt-n10">
                        依我國現行稅法規定,個人對教育機構捐款可享受減免稅捐,本校會主動向稅務單位申報捐款資料,以供捐款人扣除額使用.若您仍需要紙本收據者,請勾選索取紙本收據並填寫正確的通訊地址.
                    </v-col>
                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field :rules="[v => !needPaperReceipt || required(v), v => maxLength(v, 200)]"
                                label="通訊地址" prepend-inner-icon="mdi-home-account" v-model="donateForm.address"
                                density="compact" variant="outlined"></v-text-field>
                        </v-row>
                    </v-col>
                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field :rules="[emailRules]" label="電子郵件信箱" prepend-inner-icon="mdi-email-heart-outline"
                                v-model="donateForm.email" density="compact" variant="outlined" hint="*選填"
                                persistent-hint></v-text-field>
                        </v-row>
                    </v-col>
                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-text-field label="連絡電話" :rules="[v => maxLength(v, 50)]" prepend-inner-icon="mdi-cellphone"
                                v-model="donateForm.contactPhone" density="compact" hint="*選填" persistent-hint
                                variant="outlined"></v-text-field>
                            <v-divider class="mt-2"></v-divider>
                        </v-row>
                    </v-col>
                    <!-- <v-divider></v-divider>
                    <v-col class="mt-2">
                        <v-row cols="12">
                            退款說明:
                            <ol class="pl-5">
                                <li>捐款交易完成後7日之內如欲退款者,請洽本校校友中心進行退款作業.</li>
                                <li>信用卡退刷款項將會退還至您信用卡帳戶中,退費作業需14個工作日;因信用卡結帳日期依各發卡銀行而,您的款項可能會顯示於次月的帳單中,煩請留意.</li>
                            </ol>
                        </v-row>
                    </v-col> -->
                    <v-col class="mt-2">
                        <v-row cols="12">
                            <v-row class="pa-5" cols="12">
                                <strong>個資聲明:</strong><br />
                                <span>
                                    本校為執行捐款業務，需蒐集您的個人資料包括姓名、身分證字號、聯絡方式等，於台灣地區依捐款業務需求永久保存使用。您提供之個資受到本校【隱私權政策聲明】之保護及規範，並依據中華民國「個人資料保護法」，您可行使以下權利：(1)請求查詢或閱覽(2)製給複製本(3)請求補充或更正(4)請求停止蒐集、處理及利用(5)請求刪除。
                                </span>
                            </v-row>
                        </v-row>
                    </v-col>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <div>
                        <apple-pay-button @click="submit" v-show="showApplePayBtn" buttonstyle="black" type="contribute"
                            locale="zh-TW"></apple-pay-button>
                        <v-btn prepend-icon="mdi-cellphone-wireless" height="50" width="150" v-show="!showApplePayBtn"
                            class="bg-black" @click="submit" variant="outlined">
                            前往支付
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
            <SnackMsg></SnackMsg>
            <qrCode v-model="qrcodeDialog" :url="payUrl" :orderno="orderNo"></qrCode>
        </v-form>
    </ClientOnly>
</template>
<script setup lang="ts">

import { Console, Effect } from 'effect';
import type { VForm } from "vuetify/components";
const { isMobile } = useDevice();

const { required, numberRangeRules, IdRules, emailRules, maxLength } = useFormRules();
const { setMsg } = useMsgState();
const config = useRuntimeConfig();
const appleMerchantID = computed(() => config.public.appleMerchantID);


const supportApplePay = ref(false);
const showApplePayBtn = computed(() => donateForm.value.payType == 'ApplePay' && supportApplePay.value);

const donateForm = ref<SampleDonateList>({
    StoreOrderNo: '',
    amount: null,
    name: '',
    id: '',
    email: '',
    contactPhone: '',
    purposeId: null,
    purposeMemo: '',
    address: '',
    payType: '信用卡',
    paperReceipt: 0,
    gradYear:null,
    gradMajor:null,    
    temp:"CHINESE",
    receiptName:'',
    receiptNo:'',
})

const needPaperReceipt = ref(false);

watch(() => needPaperReceipt.value, (v) => {
    donateForm.value.paperReceipt = v ? 1 : 0;
});

const purpose = ref<DonatPurpose[]>([]);
const disableMemo = ref(false);
const form = ref<VForm>();

const loadPurpose = () => {
    $fetch("/api/purpose").then((res) => {
        purpose.value = [...res];
    });
}

loadPurpose();

const valid = ref(null);
const qrcodeDialog = ref(false);
const payUrl = ref('');
const orderNo = ref('');
let timeId: NodeJS.Timeout | null = null;
const messages = ref<string[]>([]);

watch(() => donateForm.value.purposeId, (v) => {
    disableMemo.value = v != 9999;
    donateForm.value.purposeMemo = '';
}, { immediate: true });


const addAmount = (addValue: number) => {
    donateForm.value.amount = (donateForm.value.amount ?? 0) + addValue;
}


const submit = () => {    
    form.value!.validate().then((v: any) => {
        if (v.valid) {
            if (timeId == null) {
                timeId = setTimeout(() => {
                    transToPay(donateForm.value.payType ?? '');
                    timeId = null;
                }, 500);
            }
            else {
                clearTimeout(timeId);
                timeId = null;
            }
        }
        else
        {
            setMsg("請檢查表單欄位是否正確");
        }
    })
}

//19200
//11500
const transToPay = (payType: string) => {
    switch (donateForm.value.payType) {
        case '信用卡':
            useFetch("/api/newccdonate", { method: "POST", body: donateForm.value })
                .then((res) => {
                    if (!!res.data.value)
                        navigateTo(`/ccpay/${res.data.value.StoreOrderNo}/${encodeURIComponent(res.data.value.hppUrl)}`);
                    else
                        setMsg(res.error.value?.data.statusMessage);
                });
            break;
        case 'LINE Pay':
        case 'iPASS MONEY':
            let paytype = donateForm.value.payType == 'LINE Pay' ? '11500' : '19200';
            useFetch(`/api/newoldonate/?paytype=${paytype}`, { method: "POST", body: donateForm.value })
                .then((res) => {
                    if (!!res.data.value) {
                        if (!isMobile) {
                            payUrl.value = res.data.value!.urlToken;
                            orderNo.value = res.data.value!.StoreOrderNo;
                            qrcodeDialog.value = true;
                        }
                        else {
                            navigateTo(res.data.value!.urlToken, { external: true });
                        }
                    }
                    else
                        setMsg(res.error.value?.data.statusMessage);

                });
            break;
        case 'ApplePay':
            applePay();
            break;
    }
}

nextTick(() => {
    if (Object.hasOwn(window, "ApplePaySession") && ApplePaySession.canMakePayments() === true) {
        ApplePaySession.canMakePaymentsWithActiveCard(appleMerchantID.value).then((res) => {
            supportApplePay.value = res;
        });
    }



});

const applePay = () => {
    messages.value = [...messages.value, "applePay start..."];
    const paymentData: ApplePayJS.ApplePayPaymentRequest = {
        countryCode: "TW",
        currencyCode: "TWD",
        merchantCapabilities: ["supports3DS"],
        supportedNetworks: ["amex", "masterCard", "visa"],
        total: {
            label: "STUST",
            amount: donateForm.value.amount?.toString() ?? "0",
        },
    }
    const paySession = new ApplePaySession(2, paymentData);

    paySession.oncancel = (_) => {
        setMsg("已取消交易作業");
    };

    paySession.onvalidatemerchant = (event) => {
        const payload: ApplePayLoad = {
            validationURL: event.validationURL,
            appleMerchantID: appleMerchantID.value,
            domainName: "portal.stust.edu.tw",
            displayName: "Southern Taiwan University of Science and Technology"
        }

        useFetch("/api/applepay/transsession", { method: "POST", body: payload })
            .then((res) => {
                if (!!res.data.value) {
                    paySession.completeMerchantValidation(res.data.value);
                }
                else {
                    paySession.abort();
                }
            });
    }

    paySession.onpaymentauthorized = (event) => {
        const paymentToken = JSON.stringify(event.payment.token.paymentData);
        var PPLoad: PayPayLoad = {
            paymentToken: paymentToken,
            appleMerchantID: appleMerchantID.value,
            accountid: "donate",
            amount: donateForm.value.amount?.toString() ?? "0"
        }
        callPayByPaymentToken(PPLoad, {
            success: (res) => {
                // 交易成功                
                const donateList: SampleDonateList = { ...donateForm.value, StoreOrderNo: res.orderID };
                useFetch("/api/newdonatelist", { method: "POST", body: donateList });
                navigateTo(`/thank/${res.orderID}`);
                setMsg("支付成功");
            },
            fail: (err) => {
                setMsg(`支付失敗:${err}`);
            }
        });
    }

    const callPayByPaymentToken = (payload: PayPayLoad, callBack: PayByPaymentCallBack) => {
        useFetch("/api/applepay/paybypaymenttoken", { method: "POST", body: payload })
            .then((res) => {
                if (!!res.data.value) {
                    if (res.data.value.errorCode == "NEX000") {
                        callBack.success(res.data.value);
                        paySession.completePayment(ApplePaySession.STATUS_SUCCESS);
                    }
                    else {
                        callBack.fail(res.data.value.errorMessage);
                        paySession.completePayment(ApplePaySession.STATUS_FAILURE);
                    }
                }
                else {
                    callBack.fail(res.error.value?.data.statusMessage);
                    paySession.completePayment(ApplePaySession.STATUS_FAILURE);
                }
            });
    }

    paySession.begin();

}




</script>

